import type { DrawMode } from '@racemap/utilities/types/geos';

export const modes = {
  DRAW_LINE_STRING: 'draw_line_string',
  DRAW_POLYGON: 'draw_polygon',
  DRAW_POINT: 'draw_point',
  SIMPLE_SELECT: 'simple_select',
  DIRECT_SELECT: 'direct_select',
  POINT_ON_LINE_STRING: 'point_on_line_string',
  EXPAND_LINE_STRING: 'expand_line_string',
} as const;

export const EDITING_MODES: ReadonlyArray<DrawMode> = [
  modes.DIRECT_SELECT,
  modes.DRAW_POLYGON,
  modes.DRAW_LINE_STRING,
  modes.DRAW_POINT,
  modes.POINT_ON_LINE_STRING,
  modes.EXPAND_LINE_STRING,
];

export const events = {
  CREATE: 'draw.create',
  DELETE: 'draw.delete',
  TRASH: 'draw.trash',
  UPDATE: 'draw.update',
  SELECTION_CHANGE: 'draw.selectionchange',
  MODE_CHANGE: 'draw.modechange',
  ACTIONABLE: 'draw.actionable',
  RENDER: 'draw.render',
  COMBINE_FEATURES: 'draw.combine',
  UNCOMBINE_FEATURES: 'draw.uncombine',
};

export const LAT_MIN = -90;
export const LAT_RENDERED_MIN = -85;
export const LAT_MAX = 90;
export const LAT_RENDERED_MAX = 85;
export const LNG_MIN = -270;
export const LNG_MAX = 270;
